/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Transaction } from './Transaction';
import {
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
    TransactionToJSONTyped,
} from './Transaction';

/**
 * 
 * @export
 * @interface GetTransactionsResponse
 */
export interface GetTransactionsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsResponse
     */
    balance: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsResponse
     */
    fuelPricePerUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsResponse
     */
    balanceInUsd?: number;
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof GetTransactionsResponse
     */
    transactions: Array<Transaction>;
}

/**
 * Check if a given object implements the GetTransactionsResponse interface.
 */
export function instanceOfGetTransactionsResponse(value: object): value is GetTransactionsResponse {
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    return true;
}

export function GetTransactionsResponseFromJSON(json: any): GetTransactionsResponse {
    return GetTransactionsResponseFromJSONTyped(json, false);
}

export function GetTransactionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTransactionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'],
        'fuelPricePerUsd': json['fuelPricePerUsd'] == null ? undefined : json['fuelPricePerUsd'],
        'balanceInUsd': json['balanceInUsd'] == null ? undefined : json['balanceInUsd'],
        'transactions': ((json['transactions'] as Array<any>).map(TransactionFromJSON)),
    };
}

export function GetTransactionsResponseToJSON(json: any): GetTransactionsResponse {
    return GetTransactionsResponseToJSONTyped(json, false);
}

export function GetTransactionsResponseToJSONTyped(value?: GetTransactionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance': value['balance'],
        'fuelPricePerUsd': value['fuelPricePerUsd'],
        'balanceInUsd': value['balanceInUsd'],
        'transactions': ((value['transactions'] as Array<any>).map(TransactionToJSON)),
    };
}

